import { useEffect } from 'react';
import { useTenantAwareRouter } from 'src/utils/router';

const LandingPage = () => {
  const router = useTenantAwareRouter();

  useEffect(() => {
    if (typeof router.usingSubdomain !== 'undefined') {
      router.replace('/dashboard');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.usingSubdomain]);

  return null;
};

export default LandingPage;
